import { ReactNode } from "react";
import { Box, Typography } from "@mui/material";

interface IconDetailProps {
  icon: ReactNode;
  label: string;
  children: ReactNode;
}

export function IconDetail({ icon, label, children }: IconDetailProps) {
  return (
    <Box sx={{ display: "flex", alignItems: "flex-start", gap: 1 }}>
      {icon}
      <Box>
        <Typography variant="body2" fontWeight={600}>
          {label}
        </Typography>
        {children}
      </Box>
    </Box>
  );
}
